/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ProviderAccreditationValidationAliases {
  BUTTON_SUBMIT_ACCREDITATION = 'button-submit-accreditation',
  PANEL_PROVIDER_ACCREDITATION_VALIDATION = 'panel-provider-accreditation-validation',
  PANEL_SUBMIT_ACCREDITATION = 'panel-submit-accreditation',
}
export { ProviderAccreditationValidationAliases };
